export default {
  OPERATOR_DISABLED_SET: 'OPERATOR_DISABLED_SET'
}